import React, { useState } from "react";
import "../../../styles/VocabFlashcards.css";
import { vocabData } from "../../../data/vocabData";

const VocabFlashcards = ({ onBack }) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);

  const handleNext = () => {
    setIsFlipped(false);
    setCurrentCardIndex((prev) => (prev + 1) % vocabData.length);
  };

  const handlePrevious = () => {
    setIsFlipped(false);
    setCurrentCardIndex(
      (prev) => (prev - 1 + vocabData.length) % vocabData.length
    );
  };

  return (
    <div className="vocab-flashcards">
      <button className="back-button" onClick={onBack}>
        ← 뒤로가기
      </button>
      <h2>TOEIC 필수 단어</h2>

      <div
        className={`flashcard ${isFlipped ? "flipped" : ""}`}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        <div className="flashcard-inner">
          <div className="flashcard-front">
            <h3>{vocabData[currentCardIndex].word}</h3>
          </div>
          <div className="flashcard-back">
            <p className="meaning">{vocabData[currentCardIndex].meaning}</p>
            <p className="example">{vocabData[currentCardIndex].example}</p>
          </div>
        </div>
      </div>

      <div className="flashcard-controls">
        <button onClick={handlePrevious}>이전</button>
        <span>
          {currentCardIndex + 1} / {vocabData.length}
        </span>
        <button onClick={handleNext}>다음</button>
      </div>
    </div>
  );
};

export default VocabFlashcards;
